
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as abouttvA_45cZH940c0x8nC3tePQR_bsM3gAa_452wUoIE8rkLCMMeta } from "/var/www/pecom.kz/www/frontend/pages/about.vue?macro=true";
import { default as errorviZVJtnzG8QklLO14OpNoyd3b_45fbgI8Mc6LkGcSkx9AMeta } from "/var/www/pecom.kz/www/frontend/pages/error.vue?macro=true";
import { default as _91id_93KaOkoo4d1opxwbwZCsVVPPpIGUcbO18z1lDpmN_79ocMeta } from "/var/www/pecom.kz/www/frontend/pages/news/[id].vue?macro=true";
import { default as indexP9Gpjx5wFLGmjyF8eAoT5Syu3v6y5fI9tarscx1GZZcMeta } from "/var/www/pecom.kz/www/frontend/pages/news/index.vue?macro=true";
import { default as index_eLr6ZeigaVw9I33lVsJ6LzFvnfxFwIuW8pZkKoM65QMeta } from "/var/www/pecom.kz/www/frontend/pages/index/index.vue?macro=true";
import { default as indexxe0NMWeYTMCbPZxwkhrGiC38xq_45a8loMyp1oxpR9J78Meta } from "/var/www/pecom.kz/www/frontend/pages/[page]/index.vue?macro=true";
import { default as indexko9tvHVIEoQuYtwOcddkG_45dYp3OHzGw60Pgzh_45bzaEcMeta } from "/var/www/pecom.kz/www/frontend/pages/package/index.vue?macro=true";
import { default as indexwW8cWLS1jwvMRckuHK7QPOxMvrh2vX3DF1R_45nJpadvkMeta } from "/var/www/pecom.kz/www/frontend/pages/documents/index.vue?macro=true";
import { default as indexReNZWIR_458OfaVaz1qLeJmnkpHHJ4vKlZdxFislolPv0Meta } from "/var/www/pecom.kz/www/frontend/pages/franchise/index.vue?macro=true";
import { default as index43Nua5AhcO65zfVmmTx9eBufjkGiv4PUmhkYpQK_45WB8Meta } from "/var/www/pecom.kz/www/frontend/pages/policy-cookies/index.vue?macro=true";
import { default as indexcat4Ym_GEwHWa4Br71lspkWh5b1IQ0AlBcj36pk8jUIMeta } from "/var/www/pecom.kz/www/frontend/pages/personal-policy/index.vue?macro=true";
import { default as getSugggestXv4of8s2AaoviLvkIFIrzILEzU2HMvmvhe_45RgQOmPXIMeta } from "/var/www/pecom.kz/www/frontend/pages/index/utils/getSugggest.js?macro=true";
import { default as indexVdmqdMmRVgZTpO_9creDQfqTwhULzqWGMMp4_45Vv6nEoMeta } from "/var/www/pecom.kz/www/frontend/pages/consent-processing/index.vue?macro=true";
import { default as isProductCodeTBc1zs1AP36Y1cAiFJXVMnjW_xCE0R1KITRB29hlWSEMeta } from "/var/www/pecom.kz/www/frontend/pages/index/utils/isProductCode.js?macro=true";
import { default as indexL9MQFO0NyQkFA5nzgEzGFQAGfVHZSeCwMvpejemF3PQMeta } from "/var/www/pecom.kz/www/frontend/pages/consent-advertising/index.vue?macro=true";
import { default as FaqSectionq_45ku1JPKleAfCPL56DihLezL1TKkEZxVRHzo18dLQyAMeta } from "/var/www/pecom.kz/www/frontend/pages/index/sections/FaqSection.vue?macro=true";
import { default as MapSection9d5heJgj550eek2Zp4UDdUf1sPrG7QZynYEtYXOlhrYMeta } from "/var/www/pecom.kz/www/frontend/pages/index/sections/MapSection.vue?macro=true";
import { default as getAddressInfoREi_wqKxtehYzwOGZPoyVKpegRjHKVaDX4_lulKnJuMMeta } from "/var/www/pecom.kz/www/frontend/pages/index/utils/getAddressInfo.js?macro=true";
import { default as InfoSectionMKNgR93x5VMafrZb0X_45mQ96Ngr_EzdfuKqCv5gO9NfIMeta } from "/var/www/pecom.kz/www/frontend/pages/index/sections/InfoSection.vue?macro=true";
import { default as BlockTitleEz96QxYMIW3ToGEKhpXqVmvbMZ4UHUcyCFwbTHmXSOsMeta } from "/var/www/pecom.kz/www/frontend/pages/index/components/BlockTitle.vue?macro=true";
import { default as ModalErroramDUjaM9rGONJN5_HUV4nKweWf2QoPg4DTe5Wj6_45QXsMeta } from "/var/www/pecom.kz/www/frontend/pages/index/components/ModalError.vue?macro=true";
import { default as getNeedCalculatenopQhPciVnH30UttX9_451HQu4g9MdZ_1ZBdDB4qgIGZsMeta } from "/var/www/pecom.kz/www/frontend/pages/index/utils/getNeedCalculate.js?macro=true";
import { default as CategoryhgD_ces37VSQ9CJcSIuJ6Bn8SHQRyx32_45xolU3eJA8AMeta } from "/var/www/pecom.kz/www/frontend/pages/package/components/Category.vue?macro=true";
import { default as BlockFaqBAjJkP1V6_45LCspzYoVV_O6z43EdpwqZBg_jEtghHCsgMeta } from "/var/www/pecom.kz/www/frontend/pages/franchise/components/BlockFaq.vue?macro=true";
import { default as BannerSliderNjsHLZ_O4E9LFlmluGoZO1qGuX_YGN4Sjef0kRCVN_45sMeta } from "/var/www/pecom.kz/www/frontend/pages/index/components/BannerSlider.vue?macro=true";
import { default as ModalSuccessVWTX0djEAUaIBsvGlY8EZyxoHGmq2W10MkoTRF8XS04Meta } from "/var/www/pecom.kz/www/frontend/pages/index/components/ModalSuccess.vue?macro=true";
import { default as PalletBlockl0QLGQ1Hpe_45KVGJQ6Cafxx6pQF1mWxXoLlgosgv_455UgMeta } from "/var/www/pecom.kz/www/frontend/pages/package/components/PalletBlock.vue?macro=true";
import { default as FilialOpenxGbx3UFDg2efvraj7RBS8VJb60nKMVPxBhri9fJC58UMeta } from "/var/www/pecom.kz/www/frontend/pages/franchise/components/FilialOpen.vue?macro=true";
import { default as ModalErrorcsFpGC7EOj7PyPHKoTf9VBMBPw070dgtN9_L8MhfYXAMeta } from "/var/www/pecom.kz/www/frontend/pages/franchise/components/ModalError.vue?macro=true";
import { default as AdvantageBlockKE88CxrqyYRrBFnEkHA3o9bltwKENl_459ENS0VQY0gosMeta } from "/var/www/pecom.kz/www/frontend/pages/index/components/AdvantageBlock.vue?macro=true";
import { default as ModalSuccessG5zz4wL9U4VnYy5tyNHTFCKiyGhhgckNBZch6DbimtsMeta } from "/var/www/pecom.kz/www/frontend/pages/franchise/components/ModalSuccess.vue?macro=true";
import { default as ConsultationFormguJP6gJNRcgJc_2hjp1zAuEYayIQoQWv1vRwelFn8GYMeta } from "/var/www/pecom.kz/www/frontend/pages/index/components/ConsultationForm.vue?macro=true";
import { default as DescriptionSectionWgeRmp_O7b0J0l8dszMt_45R2DFQi926MIF3kt_45EaYHfYMeta } from "/var/www/pecom.kz/www/frontend/pages/index/sections/DescriptionSection.vue?macro=true";
import { default as CategoryPallet_7MYek02yt5Dh2WlLK5bL14RNsdvrv_9Cf5ZBVGxGuwMeta } from "/var/www/pecom.kz/www/frontend/pages/package/components/CategoryPallet.vue?macro=true";
import { default as ConsultationBlockkAJ73mGA4vOpF3P2N99DzYV3m4elOgyc66X0cziGzTEMeta } from "/var/www/pecom.kz/www/frontend/pages/index/components/ConsultationBlock.vue?macro=true";
import { default as FranchiseBlock6YBj25ywgKLVzPUpEBuWdTQGmP_BwdmJTG9HvNlo1rIMeta } from "/var/www/pecom.kz/www/frontend/pages/franchise/components/FranchiseBlock.vue?macro=true";
import { default as DefaultHeaderSectiondepa5WCI6b_45rMfQpSf_9b3w8ETqPd_bW59KL1h1qu1YMeta } from "/var/www/pecom.kz/www/frontend/pages/index/sections/DefaultHeaderSection.vue?macro=true";
import { default as ConsultationFormQnVlt3KoJMug8geJmyhUDn8QHHokurLEVznSp4Ie5I8Meta } from "/var/www/pecom.kz/www/frontend/pages/franchise/components/ConsultationForm.vue?macro=true";
import { default as PalletOneng1YF7hm6HlrxXXH1ESdq_456kC4J20rS7JiWF5fBERl0Meta } from "/var/www/pecom.kz/www/frontend/pages/franchise/components/pallet/PalletOne.vue?macro=true";
import { default as getTransitCostBlockMessageolJ0eGhXh1lQytghPqN_GJkfr0lDY_Pa9wp7MxEYM_YMeta } from "/var/www/pecom.kz/www/frontend/pages/index/utils/getTransitCostBlockMessage.js?macro=true";
import { default as ConsultationBlock37zeZsEffuPJxp0azUiE2XbCBz6wMO2hu4Uy6aG4n2gMeta } from "/var/www/pecom.kz/www/frontend/pages/franchise/components/ConsultationBlock.vue?macro=true";
import { default as MapBlockU0iB8QOV3LtCv4ri_yXMQMmt47dhi6IdytI0Bk5urWYMeta } from "/var/www/pecom.kz/www/frontend/pages/franchise/components/mapBlock/MapBlock.vue?macro=true";
import { default as PalletBlockHK1JKoXjkRUv_45nbUcainLpty7VmqKTl9aqD2k8BnqKkMeta } from "/var/www/pecom.kz/www/frontend/pages/franchise/components/pallet/PalletBlock.vue?macro=true";
import { default as DefaultAdvantagesSectionw_PQ0fH__QHQxmhH2HZF4cazLhBU2VdOFM5oTKwDVW0Meta } from "/var/www/pecom.kz/www/frontend/pages/index/sections/DefaultAdvantagesSection.vue?macro=true";
import { default as TableRow8hbYSPLZd9u6FrhOaorgWHZPhipgpwZWxLFQRFiNN_45IMeta } from "/var/www/pecom.kz/www/frontend/pages/package/components/TableSearch/TableRow.vue?macro=true";
import { default as PalletBlockxri8gM0EvWeOPW0E_45GS3zCtxU_5U5UXsNiQZVL_45ruHMMeta } from "/var/www/pecom.kz/www/frontend/pages/franchise/components/pekPlus/PalletBlock.vue?macro=true";
import { default as PalletBlockHXo4wVDzZwgd0bU_45wfm0BHbAmM3acPO37pNRs8Qxo0oMeta } from "/var/www/pecom.kz/www/frontend/pages/franchise/components/mapBlock/PalletBlock.vue?macro=true";
import { default as PekPlusBlockzdLuybDMYY6tNAhMON0qfmTeQnNOWv3IWgSXlOYivyUMeta } from "/var/www/pecom.kz/www/frontend/pages/franchise/components/pekPlus/PekPlusBlock.vue?macro=true";
import { default as TableBlockKfmNu3VtsjkC4tW9MMZ9YauVqR4q9BjQ5_N7x7Yaoj0Meta } from "/var/www/pecom.kz/www/frontend/pages/package/components/TableSearch/TableBlock.vue?macro=true";
import { default as TableSearch0be0gTlXhMkNI6Pt_4562pjkxITlpzz81lnqkq3l_45wl8IMeta } from "/var/www/pecom.kz/www/frontend/pages/package/components/TableSearch/TableSearch.vue?macro=true";
import { default as getDirectionParamsFromAddressInfozDneXGLqCEY_5TGLv67tQB53ZxLhqnWVgCp4o_45SdU7YMeta } from "/var/www/pecom.kz/www/frontend/pages/index/utils/getDirectionParamsFromAddressInfo.js?macro=true";
import { default as HeadWithSearchZzs_T6ue2uoNit5wCOvtnVimPYIqFPxR0_45PtIYHA0loMeta } from "/var/www/pecom.kz/www/frontend/pages/package/components/TableSearch/HeadWithSearch.vue?macro=true";
import { default as PartnersBlockP8p_mSa_45hb6hyp59JtcO0FTMR46RO87GaK00sFYs_45EEMeta } from "/var/www/pecom.kz/www/frontend/pages/franchise/components/partnerBlock/PartnersBlock.vue?macro=true";
import { default as BlockDescriptionuL6PIzoylIQqKQ1M0FE6pVFlivLDDAHS7_458ytxguLvIMeta } from "/var/www/pecom.kz/www/frontend/pages/franchise/components/partnerBlock/BlockDescription.vue?macro=true";
export default [
  {
    name: "about___kk",
    path: "/about",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/about.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/about.vue")
  },
  {
    name: "about___ru",
    path: "/ru/about",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/about.vue")
  },
  {
    name: "error___kk",
    path: "/error",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/error.vue")
  },
  {
    name: "error___en",
    path: "/en/error",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/error.vue")
  },
  {
    name: "error___ru",
    path: "/ru/error",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/error.vue")
  },
  {
    name: "news-id___kk",
    path: "/news/:id()",
    meta: {"middleware":"check-news"},
    component: () => import("/var/www/pecom.kz/www/frontend/pages/news/[id].vue")
  },
  {
    name: "news-id___en",
    path: "/en/news/:id()",
    meta: {"middleware":"check-news"},
    component: () => import("/var/www/pecom.kz/www/frontend/pages/news/[id].vue")
  },
  {
    name: "news-id___ru",
    path: "/ru/news/:id()",
    meta: {"middleware":"check-news"},
    component: () => import("/var/www/pecom.kz/www/frontend/pages/news/[id].vue")
  },
  {
    name: "news___kk",
    path: "/news",
    meta: {"middleware":"clean-store-news"},
    component: () => import("/var/www/pecom.kz/www/frontend/pages/news/index.vue")
  },
  {
    name: "news___en",
    path: "/en/news",
    meta: {"middleware":"clean-store-news"},
    component: () => import("/var/www/pecom.kz/www/frontend/pages/news/index.vue")
  },
  {
    name: "news___ru",
    path: "/ru/news",
    meta: {"middleware":"clean-store-news"},
    component: () => import("/var/www/pecom.kz/www/frontend/pages/news/index.vue")
  },
  {
    name: "index___kk",
    path: "/",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/index.vue")
  },
  {
    name: "index___ru",
    path: "/ru",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/index.vue")
  },
  {
    name: "page___kk",
    path: "/:page()",
    meta: {"middleware":"available"},
    component: () => import("/var/www/pecom.kz/www/frontend/pages/[page]/index.vue")
  },
  {
    name: "page___en",
    path: "/en/:page()",
    meta: {"middleware":"available"},
    component: () => import("/var/www/pecom.kz/www/frontend/pages/[page]/index.vue")
  },
  {
    name: "page___ru",
    path: "/ru/:page()",
    meta: {"middleware":"available"},
    component: () => import("/var/www/pecom.kz/www/frontend/pages/[page]/index.vue")
  },
  {
    name: "package___kk",
    path: "/package",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/package/index.vue")
  },
  {
    name: "package___en",
    path: "/en/package",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/package/index.vue")
  },
  {
    name: "package___ru",
    path: "/ru/package",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/package/index.vue")
  },
  {
    name: "documents___kk",
    path: "/documents",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/documents/index.vue")
  },
  {
    name: "documents___en",
    path: "/en/documents",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/documents/index.vue")
  },
  {
    name: "documents___ru",
    path: "/ru/documents",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/documents/index.vue")
  },
  {
    name: "franchise___kk",
    path: "/franchise",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/index.vue")
  },
  {
    name: "franchise___en",
    path: "/en/franchise",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/index.vue")
  },
  {
    name: "franchise___ru",
    path: "/ru/franchise",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/index.vue")
  },
  {
    name: "policy-cookies___kk",
    path: "/policy-cookies",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/policy-cookies/index.vue")
  },
  {
    name: "policy-cookies___en",
    path: "/en/policy-cookies",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/policy-cookies/index.vue")
  },
  {
    name: "policy-cookies___ru",
    path: "/ru/policy-cookies",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/policy-cookies/index.vue")
  },
  {
    name: "personal-policy___kk",
    path: "/personal-policy",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/personal-policy/index.vue")
  },
  {
    name: "personal-policy___en",
    path: "/en/personal-policy",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/personal-policy/index.vue")
  },
  {
    name: "personal-policy___ru",
    path: "/ru/personal-policy",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/personal-policy/index.vue")
  },
  {
    name: "index-utils-getSugggest___kk",
    path: "//utils/getSugggest",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/utils/getSugggest.js")
  },
  {
    name: "index-utils-getSugggest___en",
    path: "/en//utils/getSugggest",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/utils/getSugggest.js")
  },
  {
    name: "index-utils-getSugggest___ru",
    path: "/ru//utils/getSugggest",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/utils/getSugggest.js")
  },
  {
    name: "consent-processing___kk",
    path: "/consent-processing",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/consent-processing/index.vue")
  },
  {
    name: "consent-processing___en",
    path: "/en/consent-processing",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/consent-processing/index.vue")
  },
  {
    name: "consent-processing___ru",
    path: "/ru/consent-processing",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/consent-processing/index.vue")
  },
  {
    name: "index-utils-isProductCode___kk",
    path: "//utils/isProductCode",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/utils/isProductCode.js")
  },
  {
    name: "index-utils-isProductCode___en",
    path: "/en//utils/isProductCode",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/utils/isProductCode.js")
  },
  {
    name: "index-utils-isProductCode___ru",
    path: "/ru//utils/isProductCode",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/utils/isProductCode.js")
  },
  {
    name: "consent-advertising___kk",
    path: "/consent-advertising",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/consent-advertising/index.vue")
  },
  {
    name: "consent-advertising___en",
    path: "/en/consent-advertising",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/consent-advertising/index.vue")
  },
  {
    name: "consent-advertising___ru",
    path: "/ru/consent-advertising",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/consent-advertising/index.vue")
  },
  {
    name: "index-sections-FaqSection___kk",
    path: "//sections/FaqSection",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/sections/FaqSection.vue")
  },
  {
    name: "index-sections-FaqSection___en",
    path: "/en//sections/FaqSection",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/sections/FaqSection.vue")
  },
  {
    name: "index-sections-FaqSection___ru",
    path: "/ru//sections/FaqSection",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/sections/FaqSection.vue")
  },
  {
    name: "index-sections-MapSection___kk",
    path: "//sections/MapSection",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/sections/MapSection.vue")
  },
  {
    name: "index-sections-MapSection___en",
    path: "/en//sections/MapSection",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/sections/MapSection.vue")
  },
  {
    name: "index-sections-MapSection___ru",
    path: "/ru//sections/MapSection",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/sections/MapSection.vue")
  },
  {
    name: "index-utils-getAddressInfo___kk",
    path: "//utils/getAddressInfo",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/utils/getAddressInfo.js")
  },
  {
    name: "index-utils-getAddressInfo___en",
    path: "/en//utils/getAddressInfo",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/utils/getAddressInfo.js")
  },
  {
    name: "index-utils-getAddressInfo___ru",
    path: "/ru//utils/getAddressInfo",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/utils/getAddressInfo.js")
  },
  {
    name: "index-sections-InfoSection___kk",
    path: "//sections/InfoSection",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/sections/InfoSection.vue")
  },
  {
    name: "index-sections-InfoSection___en",
    path: "/en//sections/InfoSection",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/sections/InfoSection.vue")
  },
  {
    name: "index-sections-InfoSection___ru",
    path: "/ru//sections/InfoSection",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/sections/InfoSection.vue")
  },
  {
    name: "index-components-BlockTitle___kk",
    path: "//components/BlockTitle",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/components/BlockTitle.vue")
  },
  {
    name: "index-components-BlockTitle___en",
    path: "/en//components/BlockTitle",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/components/BlockTitle.vue")
  },
  {
    name: "index-components-BlockTitle___ru",
    path: "/ru//components/BlockTitle",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/components/BlockTitle.vue")
  },
  {
    name: "index-components-ModalError___kk",
    path: "//components/ModalError",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/components/ModalError.vue")
  },
  {
    name: "index-components-ModalError___en",
    path: "/en//components/ModalError",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/components/ModalError.vue")
  },
  {
    name: "index-components-ModalError___ru",
    path: "/ru//components/ModalError",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/components/ModalError.vue")
  },
  {
    name: "index-utils-getNeedCalculate___kk",
    path: "//utils/getNeedCalculate",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/utils/getNeedCalculate.js")
  },
  {
    name: "index-utils-getNeedCalculate___en",
    path: "/en//utils/getNeedCalculate",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/utils/getNeedCalculate.js")
  },
  {
    name: "index-utils-getNeedCalculate___ru",
    path: "/ru//utils/getNeedCalculate",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/utils/getNeedCalculate.js")
  },
  {
    name: "package-components-Category___kk",
    path: "/package/components/Category",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/package/components/Category.vue")
  },
  {
    name: "package-components-Category___en",
    path: "/en/package/components/Category",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/package/components/Category.vue")
  },
  {
    name: "package-components-Category___ru",
    path: "/ru/package/components/Category",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/package/components/Category.vue")
  },
  {
    name: "franchise-components-BlockFaq___kk",
    path: "/franchise/components/BlockFaq",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/BlockFaq.vue")
  },
  {
    name: "franchise-components-BlockFaq___en",
    path: "/en/franchise/components/BlockFaq",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/BlockFaq.vue")
  },
  {
    name: "franchise-components-BlockFaq___ru",
    path: "/ru/franchise/components/BlockFaq",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/BlockFaq.vue")
  },
  {
    name: "index-components-BannerSlider___kk",
    path: "//components/BannerSlider",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/components/BannerSlider.vue")
  },
  {
    name: "index-components-BannerSlider___en",
    path: "/en//components/BannerSlider",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/components/BannerSlider.vue")
  },
  {
    name: "index-components-BannerSlider___ru",
    path: "/ru//components/BannerSlider",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/components/BannerSlider.vue")
  },
  {
    name: "index-components-ModalSuccess___kk",
    path: "//components/ModalSuccess",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/components/ModalSuccess.vue")
  },
  {
    name: "index-components-ModalSuccess___en",
    path: "/en//components/ModalSuccess",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/components/ModalSuccess.vue")
  },
  {
    name: "index-components-ModalSuccess___ru",
    path: "/ru//components/ModalSuccess",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/components/ModalSuccess.vue")
  },
  {
    name: "package-components-PalletBlock___kk",
    path: "/package/components/PalletBlock",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/package/components/PalletBlock.vue")
  },
  {
    name: "package-components-PalletBlock___en",
    path: "/en/package/components/PalletBlock",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/package/components/PalletBlock.vue")
  },
  {
    name: "package-components-PalletBlock___ru",
    path: "/ru/package/components/PalletBlock",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/package/components/PalletBlock.vue")
  },
  {
    name: "franchise-components-FilialOpen___kk",
    path: "/franchise/components/FilialOpen",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/FilialOpen.vue")
  },
  {
    name: "franchise-components-FilialOpen___en",
    path: "/en/franchise/components/FilialOpen",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/FilialOpen.vue")
  },
  {
    name: "franchise-components-FilialOpen___ru",
    path: "/ru/franchise/components/FilialOpen",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/FilialOpen.vue")
  },
  {
    name: "franchise-components-ModalError___kk",
    path: "/franchise/components/ModalError",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/ModalError.vue")
  },
  {
    name: "franchise-components-ModalError___en",
    path: "/en/franchise/components/ModalError",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/ModalError.vue")
  },
  {
    name: "franchise-components-ModalError___ru",
    path: "/ru/franchise/components/ModalError",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/ModalError.vue")
  },
  {
    name: "index-components-AdvantageBlock___kk",
    path: "//components/AdvantageBlock",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/components/AdvantageBlock.vue")
  },
  {
    name: "index-components-AdvantageBlock___en",
    path: "/en//components/AdvantageBlock",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/components/AdvantageBlock.vue")
  },
  {
    name: "index-components-AdvantageBlock___ru",
    path: "/ru//components/AdvantageBlock",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/components/AdvantageBlock.vue")
  },
  {
    name: "franchise-components-ModalSuccess___kk",
    path: "/franchise/components/ModalSuccess",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/ModalSuccess.vue")
  },
  {
    name: "franchise-components-ModalSuccess___en",
    path: "/en/franchise/components/ModalSuccess",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/ModalSuccess.vue")
  },
  {
    name: "franchise-components-ModalSuccess___ru",
    path: "/ru/franchise/components/ModalSuccess",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/ModalSuccess.vue")
  },
  {
    name: "index-components-ConsultationForm___kk",
    path: "//components/ConsultationForm",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/components/ConsultationForm.vue")
  },
  {
    name: "index-components-ConsultationForm___en",
    path: "/en//components/ConsultationForm",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/components/ConsultationForm.vue")
  },
  {
    name: "index-components-ConsultationForm___ru",
    path: "/ru//components/ConsultationForm",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/components/ConsultationForm.vue")
  },
  {
    name: "index-sections-DescriptionSection___kk",
    path: "//sections/DescriptionSection",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/sections/DescriptionSection.vue")
  },
  {
    name: "index-sections-DescriptionSection___en",
    path: "/en//sections/DescriptionSection",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/sections/DescriptionSection.vue")
  },
  {
    name: "index-sections-DescriptionSection___ru",
    path: "/ru//sections/DescriptionSection",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/sections/DescriptionSection.vue")
  },
  {
    name: "package-components-CategoryPallet___kk",
    path: "/package/components/CategoryPallet",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/package/components/CategoryPallet.vue")
  },
  {
    name: "package-components-CategoryPallet___en",
    path: "/en/package/components/CategoryPallet",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/package/components/CategoryPallet.vue")
  },
  {
    name: "package-components-CategoryPallet___ru",
    path: "/ru/package/components/CategoryPallet",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/package/components/CategoryPallet.vue")
  },
  {
    name: "index-components-ConsultationBlock___kk",
    path: "//components/ConsultationBlock",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/components/ConsultationBlock.vue")
  },
  {
    name: "index-components-ConsultationBlock___en",
    path: "/en//components/ConsultationBlock",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/components/ConsultationBlock.vue")
  },
  {
    name: "index-components-ConsultationBlock___ru",
    path: "/ru//components/ConsultationBlock",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/components/ConsultationBlock.vue")
  },
  {
    name: "franchise-components-FranchiseBlock___kk",
    path: "/franchise/components/FranchiseBlock",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/FranchiseBlock.vue")
  },
  {
    name: "franchise-components-FranchiseBlock___en",
    path: "/en/franchise/components/FranchiseBlock",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/FranchiseBlock.vue")
  },
  {
    name: "franchise-components-FranchiseBlock___ru",
    path: "/ru/franchise/components/FranchiseBlock",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/FranchiseBlock.vue")
  },
  {
    name: "index-sections-DefaultHeaderSection___kk",
    path: "//sections/DefaultHeaderSection",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/sections/DefaultHeaderSection.vue")
  },
  {
    name: "index-sections-DefaultHeaderSection___en",
    path: "/en//sections/DefaultHeaderSection",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/sections/DefaultHeaderSection.vue")
  },
  {
    name: "index-sections-DefaultHeaderSection___ru",
    path: "/ru//sections/DefaultHeaderSection",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/sections/DefaultHeaderSection.vue")
  },
  {
    name: "franchise-components-ConsultationForm___kk",
    path: "/franchise/components/ConsultationForm",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/ConsultationForm.vue")
  },
  {
    name: "franchise-components-ConsultationForm___en",
    path: "/en/franchise/components/ConsultationForm",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/ConsultationForm.vue")
  },
  {
    name: "franchise-components-ConsultationForm___ru",
    path: "/ru/franchise/components/ConsultationForm",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/ConsultationForm.vue")
  },
  {
    name: "franchise-components-pallet-PalletOne___kk",
    path: "/franchise/components/pallet/PalletOne",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/pallet/PalletOne.vue")
  },
  {
    name: "franchise-components-pallet-PalletOne___en",
    path: "/en/franchise/components/pallet/PalletOne",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/pallet/PalletOne.vue")
  },
  {
    name: "franchise-components-pallet-PalletOne___ru",
    path: "/ru/franchise/components/pallet/PalletOne",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/pallet/PalletOne.vue")
  },
  {
    name: "index-utils-getTransitCostBlockMessage___kk",
    path: "//utils/getTransitCostBlockMessage",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/utils/getTransitCostBlockMessage.js")
  },
  {
    name: "index-utils-getTransitCostBlockMessage___en",
    path: "/en//utils/getTransitCostBlockMessage",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/utils/getTransitCostBlockMessage.js")
  },
  {
    name: "index-utils-getTransitCostBlockMessage___ru",
    path: "/ru//utils/getTransitCostBlockMessage",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/utils/getTransitCostBlockMessage.js")
  },
  {
    name: "franchise-components-ConsultationBlock___kk",
    path: "/franchise/components/ConsultationBlock",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/ConsultationBlock.vue")
  },
  {
    name: "franchise-components-ConsultationBlock___en",
    path: "/en/franchise/components/ConsultationBlock",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/ConsultationBlock.vue")
  },
  {
    name: "franchise-components-ConsultationBlock___ru",
    path: "/ru/franchise/components/ConsultationBlock",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/ConsultationBlock.vue")
  },
  {
    name: "franchise-components-mapBlock-MapBlock___kk",
    path: "/franchise/components/mapBlock/MapBlock",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/mapBlock/MapBlock.vue")
  },
  {
    name: "franchise-components-mapBlock-MapBlock___en",
    path: "/en/franchise/components/mapBlock/MapBlock",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/mapBlock/MapBlock.vue")
  },
  {
    name: "franchise-components-mapBlock-MapBlock___ru",
    path: "/ru/franchise/components/mapBlock/MapBlock",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/mapBlock/MapBlock.vue")
  },
  {
    name: "franchise-components-pallet-PalletBlock___kk",
    path: "/franchise/components/pallet/PalletBlock",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/pallet/PalletBlock.vue")
  },
  {
    name: "franchise-components-pallet-PalletBlock___en",
    path: "/en/franchise/components/pallet/PalletBlock",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/pallet/PalletBlock.vue")
  },
  {
    name: "franchise-components-pallet-PalletBlock___ru",
    path: "/ru/franchise/components/pallet/PalletBlock",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/pallet/PalletBlock.vue")
  },
  {
    name: "index-sections-DefaultAdvantagesSection___kk",
    path: "//sections/DefaultAdvantagesSection",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/sections/DefaultAdvantagesSection.vue")
  },
  {
    name: "index-sections-DefaultAdvantagesSection___en",
    path: "/en//sections/DefaultAdvantagesSection",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/sections/DefaultAdvantagesSection.vue")
  },
  {
    name: "index-sections-DefaultAdvantagesSection___ru",
    path: "/ru//sections/DefaultAdvantagesSection",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/sections/DefaultAdvantagesSection.vue")
  },
  {
    name: "package-components-TableSearch-TableRow___kk",
    path: "/package/components/TableSearch/TableRow",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/package/components/TableSearch/TableRow.vue")
  },
  {
    name: "package-components-TableSearch-TableRow___en",
    path: "/en/package/components/TableSearch/TableRow",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/package/components/TableSearch/TableRow.vue")
  },
  {
    name: "package-components-TableSearch-TableRow___ru",
    path: "/ru/package/components/TableSearch/TableRow",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/package/components/TableSearch/TableRow.vue")
  },
  {
    name: "franchise-components-pekPlus-PalletBlock___kk",
    path: "/franchise/components/pekPlus/PalletBlock",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/pekPlus/PalletBlock.vue")
  },
  {
    name: "franchise-components-pekPlus-PalletBlock___en",
    path: "/en/franchise/components/pekPlus/PalletBlock",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/pekPlus/PalletBlock.vue")
  },
  {
    name: "franchise-components-pekPlus-PalletBlock___ru",
    path: "/ru/franchise/components/pekPlus/PalletBlock",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/pekPlus/PalletBlock.vue")
  },
  {
    name: "franchise-components-mapBlock-PalletBlock___kk",
    path: "/franchise/components/mapBlock/PalletBlock",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/mapBlock/PalletBlock.vue")
  },
  {
    name: "franchise-components-mapBlock-PalletBlock___en",
    path: "/en/franchise/components/mapBlock/PalletBlock",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/mapBlock/PalletBlock.vue")
  },
  {
    name: "franchise-components-mapBlock-PalletBlock___ru",
    path: "/ru/franchise/components/mapBlock/PalletBlock",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/mapBlock/PalletBlock.vue")
  },
  {
    name: "franchise-components-pekPlus-PekPlusBlock___kk",
    path: "/franchise/components/pekPlus/PekPlusBlock",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/pekPlus/PekPlusBlock.vue")
  },
  {
    name: "franchise-components-pekPlus-PekPlusBlock___en",
    path: "/en/franchise/components/pekPlus/PekPlusBlock",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/pekPlus/PekPlusBlock.vue")
  },
  {
    name: "franchise-components-pekPlus-PekPlusBlock___ru",
    path: "/ru/franchise/components/pekPlus/PekPlusBlock",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/pekPlus/PekPlusBlock.vue")
  },
  {
    name: "package-components-TableSearch-TableBlock___kk",
    path: "/package/components/TableSearch/TableBlock",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/package/components/TableSearch/TableBlock.vue")
  },
  {
    name: "package-components-TableSearch-TableBlock___en",
    path: "/en/package/components/TableSearch/TableBlock",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/package/components/TableSearch/TableBlock.vue")
  },
  {
    name: "package-components-TableSearch-TableBlock___ru",
    path: "/ru/package/components/TableSearch/TableBlock",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/package/components/TableSearch/TableBlock.vue")
  },
  {
    name: "package-components-TableSearch-TableSearch___kk",
    path: "/package/components/TableSearch/TableSearch",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/package/components/TableSearch/TableSearch.vue")
  },
  {
    name: "package-components-TableSearch-TableSearch___en",
    path: "/en/package/components/TableSearch/TableSearch",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/package/components/TableSearch/TableSearch.vue")
  },
  {
    name: "package-components-TableSearch-TableSearch___ru",
    path: "/ru/package/components/TableSearch/TableSearch",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/package/components/TableSearch/TableSearch.vue")
  },
  {
    name: "index-utils-getDirectionParamsFromAddressInfo___kk",
    path: "//utils/getDirectionParamsFromAddressInfo",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/utils/getDirectionParamsFromAddressInfo.js")
  },
  {
    name: "index-utils-getDirectionParamsFromAddressInfo___en",
    path: "/en//utils/getDirectionParamsFromAddressInfo",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/utils/getDirectionParamsFromAddressInfo.js")
  },
  {
    name: "index-utils-getDirectionParamsFromAddressInfo___ru",
    path: "/ru//utils/getDirectionParamsFromAddressInfo",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/index/utils/getDirectionParamsFromAddressInfo.js")
  },
  {
    name: "package-components-TableSearch-HeadWithSearch___kk",
    path: "/package/components/TableSearch/HeadWithSearch",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/package/components/TableSearch/HeadWithSearch.vue")
  },
  {
    name: "package-components-TableSearch-HeadWithSearch___en",
    path: "/en/package/components/TableSearch/HeadWithSearch",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/package/components/TableSearch/HeadWithSearch.vue")
  },
  {
    name: "package-components-TableSearch-HeadWithSearch___ru",
    path: "/ru/package/components/TableSearch/HeadWithSearch",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/package/components/TableSearch/HeadWithSearch.vue")
  },
  {
    name: "franchise-components-partnerBlock-PartnersBlock___kk",
    path: "/franchise/components/partnerBlock/PartnersBlock",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/partnerBlock/PartnersBlock.vue")
  },
  {
    name: "franchise-components-partnerBlock-PartnersBlock___en",
    path: "/en/franchise/components/partnerBlock/PartnersBlock",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/partnerBlock/PartnersBlock.vue")
  },
  {
    name: "franchise-components-partnerBlock-PartnersBlock___ru",
    path: "/ru/franchise/components/partnerBlock/PartnersBlock",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/partnerBlock/PartnersBlock.vue")
  },
  {
    name: "franchise-components-partnerBlock-BlockDescription___kk",
    path: "/franchise/components/partnerBlock/BlockDescription",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/partnerBlock/BlockDescription.vue")
  },
  {
    name: "franchise-components-partnerBlock-BlockDescription___en",
    path: "/en/franchise/components/partnerBlock/BlockDescription",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/partnerBlock/BlockDescription.vue")
  },
  {
    name: "franchise-components-partnerBlock-BlockDescription___ru",
    path: "/ru/franchise/components/partnerBlock/BlockDescription",
    component: () => import("/var/www/pecom.kz/www/frontend/pages/franchise/components/partnerBlock/BlockDescription.vue")
  }
]